export default {
	OrganizationTransferInvoices: [],
	Total: 0,
	OrganizationTransferInvoice: {},
	IsLoadingData: false
};
